module.exports = __webpack_public_path__ + "static/media/mustache.b8a0ea6b.jpg";